import { TextField, Typography } from "@mui/material";

import { GetHierarchyNodeDescendantResponse } from "domains/nodes/services/node-service";
import { useGetHierarchyNodeById } from "../../services/use-hierarchynodes-api";

interface INodePathProps {
    nodeId: number | null;
    labelText?: string | null;
    showAsText?: boolean;
    textDisplay?: "inline";
    separator?: string;
}

const InnerNodePath = (props: INodePathProps) => {
    const { loading, data } = useGetHierarchyNodeById(props.nodeId as number);

    const formatPath = (descendants: GetHierarchyNodeDescendantResponse[]): string => {
        if (descendants) {
            return descendants.map((item: GetHierarchyNodeDescendantResponse) => item.name).join(props.separator ?? "/");
        }
        return "";
    };

    return (
        <>
            {!loading && data !== null ? (
                <>
                    {props.showAsText && <Typography display={props.textDisplay}>{formatPath(data.descendants)}</Typography>}
                    {!props.showAsText && (
                        <TextField
                            InputProps={{
                                readOnly: true,
                            }}
                            fullWidth
                            id="partition-hierarchyPath"
                            inputProps={{ "aria-labelledby": "partition-hierarchyPath" }}
                            label={props.labelText}
                            defaultValue={formatPath(data.descendants)}
                        />
                    )}
                </>
            ) : (
                <></>
            )}
        </>
    );
};

const NodePath = (props: INodePathProps) => {
    if (!props.nodeId) {
        return null;
    }

    return <InnerNodePath textDisplay={props.textDisplay} showAsText={props.showAsText} nodeId={props.nodeId} labelText={props.labelText}></InnerNodePath>;
};

export default NodePath;
